import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelMaterialImport_ds_get_material_by_lookup_and_projectService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lookupcode?: string, project_lookupcode?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, PackagingLookups?: { PackagingId?: number, Packaging?: { ShortName?: string } }[] } }> 
  {
    let url = `${environment.backendUrl}api/ExcelMaterialImport/datasources/ds_get_material_by_lookup_and_project/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lookupcode?: string, project_lookupcode?: string    }) {
      return false;
    }
}
